export const frontmatter = {
    "draft": true,
    "title": "Permissions",
    "description": "Permission system in OnnIA.",
    "sidebar_label": "Permissions",
    "sidebar_group": "reference",
    "sidebar_order": 3
}

export const toc = []